import { LockOutlined } from "@ant-design/icons";
import { Carousel, Col, Form, Input, message, Row, Typography } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import image1 from "../assets/image1.svg";
import image2 from "../assets/image2.svg";
import logo from "../assets/logo.png";
import CustomButton from "../common/CustomButton";
import AuthService from "../services/Auth/AuthService";

const { Title, Text } = Typography;

function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleResetPassword = () => {
    if (!newPassword || !confirmPassword) {
      message.error("Please fill in all fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match");
      return;
    }
    setLoading(true);
    AuthService.resetPassword({
      email: location?.state?.email,
      newPassword,
      otp: null,
    })
      .then((response) => {
        if (response.status === 200) {
          message.success("Password updated successfully.");
          navigate("/login");
        } else {
          message.error(response.message || "Failed to update password");
        }
      })
      .catch((error) => {
        message.error(error.message || "An unexpected error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const isSubmitDisabled =
    loading ||
    !newPassword ||
    !confirmPassword ||
    newPassword !== confirmPassword;

  return (
    <Row className="h-screen overflow-hidden">
      <Col
        xs={24}
        md={12}
        className="flex items-center justify-center h-full overflow-auto"
      >
        <div className="relative w-full max-w-lg p-8 bg-white shadow-2xl rounded-xl transition-transform duration-700">
          <div className="text-center mb-6">
            <img
              src={logo}
              alt="Conti Logo"
              className="demo-logo-vertical text-center w-3/5"
            />
            <Title level={4}>Reset Password</Title>
            <Text className="text-tertiary">
              Enter a new password for your account
            </Text>
          </div>

          <Form name="resetPassword" layout="vertical">
            <Form.Item
              name="newPassword"
              rules={[{ required: true, message: "Please enter a new password" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter new password"
                className="rounded-md p-3"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              rules={[
                { required: true, message: "Please confirm your password" },
                () => ({
                  validator(_, value) {
                    if (!value || value === newPassword) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Confirm new password"
                className="rounded-md p-3"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Item>
            <CustomButton
              type="primary"
              onClick={handleResetPassword}
              className={`w-full h-11 bg-primary hover:!bg-teal-500 rounded-md ${isSubmitDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={isSubmitDisabled}
            >
              {loading ? "Updating..." : "Update Password"}
            </CustomButton>
          </Form>
        </div>
      </Col>
      <Col xs={0} md={12} className="hidden md:flex h-screen">
        <div className="relative h-full w-full">
          <Carousel dotPosition="top" autoplay autoplaySpeed={8000} speed={2000}>
            <img src={image1} alt="image1" />
            <img src={image2} alt="image2" />
          </Carousel>
        </div>
      </Col>
    </Row>
  );
}

export default ResetPassword;